import React from 'react';
import cl from "../styles/ManageStudentsPage.module.css"
import stud from "../Assets/icons/school_manage_st.svg"

const ManageStudentsPage = () => {
    return (
        <div className={cl.wrap}>
            <h1>Manage students</h1>
            <div className={cl.content}>
                <div className={cl.icon}>
                    <img src={stud} alt={"stud"}/>
                </div>
                <div className={cl.text}>
                    No students enrolled yet
                    <span>
                        This course does not have any students at the moment. You can start by enrolling students to begin tracking their progress and submissions.
                    </span>
                </div>
                <button className={cl.enroll}>
                    Enroll students
                </button>
            </div>
            <button className={cl.back}>
                Back
            </button>
        </div>
    );
};

export default ManageStudentsPage;